import { render, staticRenderFns } from "./newHouseDetail.vue?vue&type=template&id=62274994&scoped=true&"
import script from "./newHouseDetail.vue?vue&type=script&lang=js&"
export * from "./newHouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./newHouseDetail.vue?vue&type=style&index=0&id=62274994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274994",
  null
  
)

export default component.exports